import { render, staticRenderFns } from "./WheelFortuneTimerButton.vue?vue&type=template&id=6d4ad6e5&scoped=true"
import script from "./WheelFortuneTimerButton.vue?vue&type=script&lang=js"
export * from "./WheelFortuneTimerButton.vue?vue&type=script&lang=js"
import style0 from "./WheelFortuneTimerButton.vue?vue&type=style&index=0&id=6d4ad6e5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4ad6e5",
  null
  
)

export default component.exports